import script from "./NotEnoughMemory.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotEnoughMemory.vue?vue&type=script&setup=true&lang=ts"

import "./NotEnoughMemory.vue?vue&type=style&index=0&id=79010257&lang=scss"

const __exports__ = script;

export default __exports__